export default function (state) {
    if (!state.mainProps.hideComponents) {
        return [];
    }

    return state.mainProps.hideComponents.split(',');
}
